import {
    AdobeLogo,
    JPMorganLogo,
    nasalogo,
    PWCLogo,
    RippleMatchLogo,
    SAPLogo,
    SalesforceLogo,
    AmazonLogo,
    KumonLogo,
    KimleyHornLogo,
    ExperianLogo,
    GitHubLogo,
    YouTubeLogo,
    LoroPianaLogo,
    BlackrockLogo,
    CapitalGroupLogo,
    BrenLogo,
    RaytheonLogo,
    GlobalFoundriesLogo,
    BachemLogo,
    RadixLogo,
    ReitLogo,
    JobrightLogo,
    BiologicalSciencesLogo,
    UCIAthleticsLogo,
    UnicornPerformLogo,
    VinaCapitalLogo,
    CapitalOneLogo,
    EpicSystemsLogo,
    OCHealthLogo,
    CenterviewPartnersLogo,
    BarclaysLogo,
    DisneyLogo,
    WellsFargoLogo,
    HyundaiLogo,
    paramountLogo,
    CreditKarmaLogo,
    TeslaLogo,
    VisaLogo,
    HPELogo,
    ConcordiaLogo,
    AONLogo,
    ARMLogo,
    OneStreamLogo,
    OLIPOPLogo,
    DeloitteLogo,
    doordashlogo,
    InyoLogo,
    UPSLogo,
    CSBHALogo,
    WeiAestheticLogo,
    LaunchpointLogo,
    intellogo,
    PalantirLogo,
    RobloxLogo,
    CelsiusLogo,
    TacoBellLogo,
    NotionLogo,
    RocheLogo,
    TinderLogo
  } from "../Assets";
  import DefaultHeadshot from "./ActiveHeadshots/Default Headshot.webp";
  

export const companyHash = {
    "Aarush Inamdar": AdobeLogo,
    "Alex Kao": JPMorganLogo,
    "Sarah Kim": KumonLogo,
    "Yan Amy Zhou": JPMorganLogo,
    "Anna Shan": BlackrockLogo,
    "Mason Whang": LoroPianaLogo, 
    "Andrew Sou": RocheLogo,
    "Annie Nguyen": AdobeLogo,
    "Alexis Lin": AmazonLogo,
    "Catelynn Chen": CapitalGroupLogo,
    "Elle Hsu": TinderLogo,
    "Anuj Patel": nasalogo,
    "Andrew Hauber": CapitalOneLogo,
    "Allen Lai": CapitalGroupLogo,
    "Cindy Chen": WeiAestheticLogo,
    "Daniel Kim": EpicSystemsLogo,
    "Donny Chau": GlobalFoundriesLogo,
    "Katie Wang": GitHubLogo,
    "Lauren Cho": RaytheonLogo,
    "Max Vano": SalesforceLogo,
    "Pranay Macherla": TeslaLogo,
    "Mina Nguyen": AONLogo,
    "Tommy Nguyen": CelsiusLogo,
    "Alex Sriprathum": KimleyHornLogo,
    "Nico Simonian": ARMLogo,
    "Carl Qiao": PWCLogo,
    "Logan Kim": CenterviewPartnersLogo,
    "Ryan Park": ExperianLogo,
    "Melinda Do": SAPLogo,
    "Travis Yen": JobrightLogo,
    "Tyler Ho": BarclaysLogo,
    "Erin Tran": ReitLogo,
    "Bradly Ho": PWCLogo,
    "Brandon Koh": YouTubeLogo,
    "David Kim": BachemLogo,
    "Ashley Kang": WellsFargoLogo,
    "Millicent Mei": LaunchpointLogo,
    "Brandon Peng": CapitalOneLogo,
    "Nicole Kwan": AmazonLogo,
    "Ashlyn Wong": DisneyLogo,
    "Gabrielle Reyes": UCIAthleticsLogo,
    "Grace Ryu": OLIPOPLogo,
    "Samantha Lee": HyundaiLogo,
    "Henry Lee": OneStreamLogo,
    "Rishi Murumkar": NotionLogo,
    "Izella Han": RippleMatchLogo,
    "Ashton Creveling": paramountLogo,
    "Luis Esparza": DisneyLogo,
    "Max Truong": PalantirLogo,
    "Ethan Le": intellogo,
    "Ethan Lee": CapitalGroupLogo,
    "Megan Yung": OCHealthLogo,
    "Christine Lee": TacoBellLogo,
    "James Fitzpatrick": ConcordiaLogo,
    "Ava Lily Tran": VinaCapitalLogo,
    "Braeden Yeoh": DeloitteLogo,
    "Daniela Herrera": RobloxLogo,
    "Megan Dinh": TeslaLogo,
    "Emily Chien": UPSLogo,
    /* Cropped to the apple alone: the published lockup carries the name in
       type beside it, which reads as a caption rather than a mark at the size
       this overlay draws. Waiting on her headshot, like the rest of Beta. */
    "Sophie Choi": CSBHALogo,
    "Pranav Rao": TeslaLogo,
    "Default Headshot": DefaultHeadshot,
  };
    